<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">Conflicts</h4>
        <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
    </div>
    <mat-dialog-content class="">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="mat-custom-table">
                            <div class="table-responsive">
                                <table class="w-100" mat-table [dataSource]="dataSource" matSort aria-describedby="">

                                    <!-- Hosted By -->
                                    <ng-container matColumnDef="Name">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Host Name
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="WrapData"
                                            [title]="element.UserName">
                                            {{ element.UserName }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Date">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Date
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="WrapData"
                                            [innerHTML]="element.StartDate | ordinalDate : element.EndDate">
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Time">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Time
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="WrapData">
                                            {{ (element.StartDate | date : dateFormat.shortTime) + '-' +
                                            (element.EndDate | date : dateFormat.shortTime) }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="ErrorMessage">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Reason
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="WrapData"
                                            [title]="element.ErrorMessage" class="text-danger">
                                            {{ element.ErrorMessage }}
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns"
                                        [ngClass]="{ Inactive: !row.isActive }">
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialogue-footer p-3">
                <button class="btn btn-info" type="button" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>
    </mat-dialog-content>
</div>